import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { setNavigate } from './navigationServiceFunctions';

export default function NavigationService() {
    const navigate = useNavigate();

    useEffect(() => {
        setNavigate(navigate);
    }, [navigate]);

    return null
}
